import { Plus } from "lucide-react";

export default function Marquee({ items, testid = "marquee" }) {
  const row = (hidden) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden}>
      {items.map((it, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`whitespace-nowrap px-5 font-display text-[11vw] font-semibold uppercase leading-none tracking-tight md:px-8 md:text-[5.5vw] ${
              i % 2 === 0 ? "text-white" : "text-stroke"
            }`}
          >
            {it}
          </span>
          <Plus className="size-6 shrink-0 text-molten md:size-8" strokeWidth={1.5} />
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid={testid}
      className="marquee-hover overflow-hidden border-y border-white/10 bg-steel py-6 md:py-8"
    >
      <div className="animate-marquee flex w-max">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
